import { getQuery } from './query';

export const getListQueryConcatQueryfilter = (queryString: string, espaceAmpersand = false) => {
  const listQuery = getQuery('list');
  if (!listQuery) return queryString;

  return queryString.indexOf('?') > -1
    ? `${queryString}${espaceAmpersand ? '%26' : '&'}list=${listQuery}`
    : `${queryString}?list=${listQuery}`;
};
